<!-- eslint-disable vue/html-indent -->
<template>
  <div class="ignore-theme">
    <div :class="$b()">
      <!-- Use series breadcrumb as fallback -->
      <span
        data-breadcrumb-default-container
        :class="$b('breadcrumb-container')"
      >
        <VisionLink
          :href="seriesTarget"
          :class="$b('link')"
          :mono-font="true"
        >
          <span>{{ seriesLabel }}</span>
        </VisionLink>
      </span>

      <!-- Use dynamic breadcrumb when coming from landing page -->
      <span
        data-breadcrumb-container
        :class="$b('breadcrumb-container')"
        style="display: none"
      >
        <a
          href=""
          data-breadcrumb-link
          :class="$b('link')"
        >
          <span data-breadcrumb-label />
        </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductBreadcrumbs',

  props: {
    hasLimitedEditionPart: {
      type: Boolean,
      default: false,
    },
    isLimitedEdition: {
      type: Boolean,
      default: false,
    },
    productName: {
      type: String,
      default: '',
    },
    seriesLabel: {
      type: String,
      default: '',
    },
    seriesTarget: {
      type: String,
      default: '',
    },
  },

  setup() {
    const pageStore = usePageStore()

    useHead({
      script: [{
        // Includes ~/public/scripts/breadcrumbs.js
        src: '/scripts/breadcrumbs.js',
        type: 'text/javascript',
        key: 'breadcrumb-injection'
      }]
    })

    return { pageTheme: pageStore.pageTheme }
  },
  computed: {
    schema() {
      const schema = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: 'https://www.sungod.co/',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name:
              this.isLimitedEdition || this.hasLimitedEditionPart
                ? 'Limited Editions'
                : this.seriesLabel,
            item: `https://www.sungod.co${this.seriesTarget}`,
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: this.productName,
          },
        ],
      }

      return schema
    },
    jsonld() {
      return this.schema
    },
  },
  mounted() {
    const containers = document.querySelectorAll(
      '[data-breadcrumb="set"], [data-breadcrumb="series"]'
    )
    containers.forEach((container) => {
      container.style.display = 'inline'
    })
  },
}
</script>

<style lang="postcss">
.ProductBreadcrumbs {
  @apply leading-normal
    text-xxs
    overflow-hidden;

  .is-dark-chrome-theme & {
    @apply text-white;
  }
}

.ProductBreadcrumbs,
.ProductBreadcrumbs__link {
  @apply text-mid-grey;
}

.ProductBreadcrumbs__breadcrumb-container {
  @apply inline overflow-hidden;

  &:after:has(+ span[data-breadcrumb="set"]) {
    @apply content-['/'] mx-2 text-mid-grey;
  }

  &:not(:first-child) {
    .ProductBreadcrumbs__link {
      @apply overflow-hidden;
    }
  }

  &:first-child {
    @apply flex-shrink-0;
  }
}

.ProductBreadcrumbs__link {
  @apply inline space-x-xxxs;

  &:hover {
    @apply underline;
  }

  span {
    @apply overflow-hidden text-ellipsis;
  }
}

.ProductBreadcrumbs__product {
  @apply opacity-100;
}
</style>
